var React = require('react');

function ManuallyEnteredReading (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.96447 1.00001L1 3.96527L3.96447 6.93053L6.92894 3.96527L3.96447 1.00001Z","stroke":"#4D4D4D","strokeWidth":"0.998369","strokeMiterlimit":"10"}));
}

ManuallyEnteredReading.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = ManuallyEnteredReading;

ManuallyEnteredReading.default = ManuallyEnteredReading;
